import { f as fail } from "../../../../../chunks/index.js";
import { g as get_data } from "../../../../../chunks/get_data.js";
import { m as mapFormFields } from "../../../../../chunks/mapFormFields.js";
import "../../../../../chunks/api.js";
const load = async (event) => {
  return get_data(event);
};
const actions = {
  update_base_data: async ({ request, locals, fetch, params }) => {
    const fields = ["firstName", "lastName", "gender", "cv_placeOfBirth", "cv_nationality", "dateOfBirth", "maidenName", "cv_degree", "status", "unitId", "cv_mainEmployer", "cv_countryOfBirth"];
    let payload = await mapFormFields(request, fields);
    const response = await fetch(`$api/employee/${params.uuid}`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify(payload)
    });
    const base_data = await response.json();
    if (response.ok) {
      return base_data;
    }
    return fail(400, {
      message: "Failed to update base data",
      message_status: "failed"
    });
  },
  update_bank_info: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const accountName = data.get("accountName");
    const accountNumber = data.get("accountNumber");
    const bankName = data.get("bankName");
    const bicSwift = data.get("bicSwift");
    const iban = data.get("iban");
    const response = await fetch(`$api/employee/${params.uuid}/bank-account`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify({ accountName, accountNumber, bankName, bicSwift, iban })
    });
    const bank_info_data = await response.json();
    if (response.ok) {
      return bank_info_data;
    }
    return fail(400, {
      message: "Failed to update bank information",
      message_status: "failed"
    });
  },
  update_cv: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const nationality = data.get("nationality");
    const religiousAffiliation = data.get("religiousAffiliation");
    const familyStatus = data.get("familyStatus");
    const graduation = data.get("graduation");
    const motorVehicleLicense = data.get("motorVehicleLicense");
    const employeeStatus = data.get("employeeStatus");
    const response = await fetch(`$api/employee/${params.uuid}/cv`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify({
        nationality,
        religiousAffiliation,
        familyStatus,
        graduation,
        motorVehicleLicense,
        currentEmploymentStatus: employeeStatus
      })
    });
    try {
      const cv_data = await response.json();
      if (response.ok) {
        return cv_data;
      }
    } catch (e) {
      console.error("Error updating CV", e);
    }
    return fail(400, {
      message: "Failed to update CV",
      message_status: "failed"
    });
  },
  health_insurance: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const insuranceName = data.get("insuranceName");
    const insuranceNumber = data.get("insuranceNumber");
    const isPublic = data.get("isPublic");
    const previouslyInsuredBy = data.get("previouslyInsuredBy");
    const payload = { insuranceName, insuranceNumber, isPublic, previouslyInsuredBy };
    const response = await fetch(`$api/employee/${params.uuid}/health-insurance`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify(payload)
    });
    await response.json();
    const socialSecurityNumber = data.get("socialSecurityNumber");
    const taxationClass = data.get("taxationClass");
    const childAllowance = data.get("childAllowance");
    const religiousAffiliation = data.get("religiousAffiliation");
    const taxId = data.get("taxId");
    const familyStatus = data.get("familyStatus");
    const responseCv = await fetch(`$api/employee/${params.uuid}`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify({ taxId, cv: { socialSecurityNumber, familyStatus, taxationClass, childAllowance, religiousAffiliation } })
    });
    const cv_data = await responseCv.json();
    if (response.ok && responseCv.ok) {
      return cv_data;
    }
    return fail(400, {
      message: "Failed to update health insurance",
      message_status: "failed"
    });
  },
  // /api/address/:addressUuid, /api/employee/:employeeUUID
  update_employee_status: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const status = data.get("status");
    try {
      await fetch(`$api/employee/${params.uuid}/employment-status`, {
        method: "DELETE",
        headers: locals.fetchAuthHeaders
      });
      const response = await fetch(`$api/employee/${params.uuid}`, {
        method: "PUT",
        headers: locals.fetchAuthHeaders,
        body: JSON.stringify({
          employmentStatus: status
        })
      });
      const employee_status_data = await response.text();
      if (response.ok) {
        return employee_status_data;
      }
    } catch (e) {
      console.error("Error updating employee status", e);
    }
    return fail(400, {
      message: "Failed to update employee status",
      message_status: "failed"
    });
  },
  // /api/address/:addressUuid, /api/employee/:employeeUUID
  update_employee: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const address_uuid = data.get("address_uuid");
    const address_name = data.get("address_name");
    const address_addressAddendum = data.get("address_addressAddendum") ?? null;
    const address_street = data.get("address_street");
    const address_zip = data.get("address_zip");
    const address_place = data.get("address_place");
    const address_number = data.get("address_number");
    const address_country = data.get("address_country");
    const mobile = data.get("mobile");
    const email = data.get("email");
    const response = await fetch(`$api/employee/${params.uuid}`, {
      method: "PUT",
      headers: locals.fetchAuthHeaders,
      body: JSON.stringify({
        address: {
          addressUuid: address_uuid,
          place: address_place,
          zip: address_zip,
          street: address_street,
          number: address_number,
          country: address_country,
          name: address_name,
          addressAddendum: address_addressAddendum
        },
        mobile,
        email
      })
    });
    if (response.ok) {
      return {
        "message": "success"
      };
    }
    return fail(response.status, {
      message: "Failed to update address",
      message_status: "failed"
    });
  },
  update_employee_qualifications: async ({ request, locals, fetch, params }) => {
    const data = await request.formData();
    const qualifications = {
      graduation: data.get("graduation"),
      degree: data.get("degree"),
      currentStatus: data.get("cv_currentStatus"),
      workExperiences: data.get("workExperiences"),
      shirtSize: data.get("shirtSize"),
      motorVehicleLicense: data.get("motorVehicleLicense") ?? "0",
      pantsSize: data.get("pantsSize"),
      shoeSize: data.get("shoeSize"),
      height: data.get("height"),
      hairColor: data.get("hairColor")
    };
    try {
      const response = await fetch(`$api/employee/${params.uuid}`, {
        method: "PUT",
        headers: locals.fetchAuthHeaders,
        body: JSON.stringify({ cv: qualifications })
      });
      const qualifications_data = await response.json();
      if (response.ok) {
        return qualifications_data;
      }
    } catch (e) {
      console.error("Error updating qualifications", e);
    }
    return fail(400, {
      message: "Failed to update qualifications",
      message_status: "failed"
    });
  },
  // [PUT] /api/employee/:employeeUuid/reminder/:employeeReminderId
  update_reminders: async ({ request, locals, fetch, params }) => {
    const formData = await request.formData();
    const reminderJsons = formData.getAll("reminderJson[]");
    const reminders = reminderJsons.map((reminderJson) => {
      return {
        ...JSON.parse(reminderJson),
        doneAt: (/* @__PURE__ */ new Date()).toISOString()
      };
    });
    for (const reminder of reminders) {
      const response = await fetch(`$api/employee/${params.uuid}/reminder/${reminder.employeeReminderId}`, {
        method: "PUT",
        headers: locals.fetchAuthHeaders,
        body: JSON.stringify(reminder)
      });
      if (!response.ok) {
        console.error("Failed to update reminder", reminder);
      }
    }
    return {
      "message": "success",
      "alias": "update_reminders"
    };
  },
  //     /api/employee/:employeeUuid/avatar
  upload_avatar: async ({ request, locals, fetch, params }) => {
    const formData = await request.formData();
    const form = new FormData();
    const avatar = formData.get("avatar");
    if (!avatar) {
      return fail(400, {
        message: "No avatar found",
        message_status: "failed"
      });
    }
    form.append("file", avatar);
    const response = await fetch(`$api/employee/${params.uuid}/avatar`, {
      method: "POST",
      headers: {
        Authorization: locals.fetchAuthHeaders["Authorization"],
        ...request.headers
      },
      body: form
    });
    if (response.ok) {
      return {
        "message": "success",
        "alias": "upload_avatar"
      };
    }
    return fail(400, {
      message: "Failed to upload avatar",
      message_status: "failed"
    });
  },
  //    /api/employee/:uuid/timeline
  publish_to_timeline: async ({ request, locals, fetch, params }) => {
    const formData = await request.formData();
    const content = formData.get("content");
    const response = await fetch(`$api/employee/${params.uuid}/timeline`, {
      method: "POST",
      headers: {
        Authorization: locals.fetchAuthHeaders["Authorization"],
        ...request.headers
      },
      body: JSON.stringify({ content })
    });
    if (response.ok) {
      return {
        message: "success",
        alias: "publish_to_timeline"
      };
    }
    return fail(400, {
      message: "Failed to upload avatar",
      message_status: "failed"
    });
  }
};
export {
  actions,
  load
};
//# sourceMappingURL=_page.server.ts.js.map
